interface ContructorParams {
	id: number
	email: string
	name: string
	surname: string
	team: number
}

export class TournamentMember {
	public id: number
	public email: string
	public name: string
	public surname: string
	public team: number

	constructor(params: ContructorParams) {
		this.id = params.id
		this.email = params.email
		this.name = params.name
		this.surname = params.surname
		this.team = params.team
	}
}
